module.exports = __webpack_public_path__ + "img/image_12.df8e1a9e.png";